import { useMutation as e } from "@maat/store-hooks";
import { authApi as t } from "@maat/api-main";
//#region src/queries/otp/useRequestOtpMutation.ts
var n = () => e({ mutationFn: t.requestOtp });
//#endregion
export { n as useRequestOtpMutation };
